var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderPage'),_c('div',{staticClass:"content"},[_c('SlideShow')],1),_c('h2',[_vm._v("关于我们")]),_c('CompanyPage'),_c('h2',[_vm._v("产品介绍")]),_c('ProductcsText'),_c('h2',[_vm._v("成功案例")]),_c('SuccessText'),_c('FooterPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }